export default __webpack_public_path__ + "static/media/pursuit-menu-profile-on.15f717c6.svg";